export const setProductsFilter = (payload) => ({
    type: 'SET_PRODUCTS_FILTER',
    payload,
});

export const clearProductsStore = () => ({
    type: 'CLEAR_PRODUCTS_STORE',
});

export const setProductsSubFilter = (payload) => ({
    type: 'SET_PRODUCTS_SUB_FILTER',
    payload,
});

export const clearProductsSubStore = () => ({
    type: 'CLEAR_PRODUCTS_SUB_STORE',
});
